import React from "react";

export default function Placeholder() {
  return (
    <>
      <div className="Body">
        <header>
          <span className="text-decoration-underline">Placeholder</span>
        </header>
      </div>
    </>
  );
}
